import React from 'react';
import { Chart } from '../../components/Chart';
import { Table } from '../../components/Table';
import { useTheme } from '../../contexts/ThemeContext';

export const SalesAnalysisPage: React.FC = () => {
  const { theme } = useTheme();

  return (
    <div className={`content-section ${theme.isDark ? 'dark' : 'light'}`}>
      <h2>Анализ продаж</h2>
      <div style={{ display: 'flex', gap: '20px', marginBottom: '20px' }}>
        <Chart
          theme={theme}
          type="line"
          title="Динамика продаж по дням"
          data={[
            { label: 'Пн', value: 45000 },
            { label: 'Вт', value: 52000 },
            { label: 'Ср', value: 48000 },
            { label: 'Чт', value: 58000 },
            { label: 'Пт', value: 67000 },
            { label: 'Сб', value: 72000 },
            { label: 'Вс', value: 55000 }
          ]}
        />
        <Chart
          theme={theme}
          type="pie"
          title="Маржинальность по категориям"
          data={[
            { label: 'Напитки 35.4%', value: 354, color: '#003497' },
            { label: 'Молочные 22.8%', value: 228, color: '#4d7fff' },
            { label: 'Мясные 18.5%', value: 185, color: '#80a3ff' },
            { label: 'Хлеб 15.2%', value: 152, color: '#b3ccff' }
          ]}
        />
      </div>
      <Table
        title="Продажи по категориям за текущий месяц"
        columns={[
          { key: 'category', title: 'Категория', width: '30%' },
          { key: 'items_sold', title: 'Продано ед.', width: '20%' },
          { key: 'revenue', title: 'Выручка, сом', width: '25%' },
          { key: 'margin', title: 'Маржа %', width: '15%' },
          { key: 'trend', title: 'Тренд', width: '10%' }
        ]}
        data={[
          { id: '1', category: 'Хлебобулочные', items_sold: '3,245', revenue: '162,250', margin: '15.2%', trend: '↑', is_deleted: false },
          { id: '2', category: 'Молочные', items_sold: '2,876', revenue: '287,600', margin: '22.8%', trend: '↑', is_deleted: false },
          { id: '3', category: 'Мясные', items_sold: '1,567', revenue: '470,100', margin: '18.5%', trend: '↓', is_deleted: false },
          { id: '4', category: 'Напитки', items_sold: '4,123', revenue: '206,150', margin: '35.4%', trend: '↑', is_deleted: false }
        ]}
        theme={theme}
        readOnly={true}
      />
    </div>
  );
};
